module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/078fc002c9422410ebe3d4fd73d8639e.png";